export default function(text) {
    const alert = document.querySelector(".alert__container");
    var alertContent = (text !== undefined) ? text : 'Please fill out all fields to continue.';
    alert.innerHTML = alertContent;
    alert.style.display = "block";
  
    setTimeout(() => {
      alert.style.display = "none";
    }, 4000);
}
